// removed by extract-text-webpack-plugin
module.exports = {"map":"style__map___2bb0w","venues":"style__venues___gtDrH","venue":"style__venue___1CKrQ","address":"style__address___9PKSe","address-line":"style__address-line___qIpT2","address-actions":"style__address-actions___1_meY","address-action":"style__address-action___37k7Z","new-venue-button":"style__new-venue-button___1Vs8z","venue-to-delete":"style__venue-to-delete___zRXgg"};


//////////////////
// WEBPACK FOOTER
// ./components/VenueList/style.scss
// module id = 1319
// module chunks = 0